let BaseURL = process.env.REACT_APP_API_BASEURL;

export function get(request, params, options) {
  const token = sessionStorage.getItem("authentication");
  options.headers = new Headers({
    "Content-Type": "application/json",
    Authorization: "Bearer " + token,
  });
  let url = new URL(BaseURL + request);
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: "GET",
      headers: options.headers,
      crossDomain: true,
    })
      .then((response) => response)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function post(request, body, options) {
  const token = sessionStorage.getItem("authentication");
  options.headers = new Headers({
    "Content-Type": "application/json",
    Authorization: "Bearer " + token,
  });
  let url = new URL(BaseURL + request);
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: "POST",
      body: body,
      headers: options.headers,
      crossDomain: true,
    })
      .then((response) => response)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function remove(request, body, options) {
  const token = sessionStorage.getItem("authentication");
  options.headers = new Headers({
    "Content-Type": "application/json",
    Authorization: "Bearer " + token,
  });
  let url = new URL(BaseURL + request);
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: "DELETE",
      headers: options.headers,
      crossDomain: true,
    })
      .then((response) => response)
      .then((res) => {
        if (res.status === 403 || res.status === 401) {
          window.location.href = "/auth";
        }
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getCsrfToken() {
  return new Promise((resolve, reject) => {
    let csrfToken = sessionStorage.getItem("csrf_token");
    let csrfTokenExpiry = sessionStorage.getItem("csrf_token_expiry");

    // Check if the CSRF token exists and if it's still valid
    if (csrfToken && csrfTokenExpiry && new Date() < new Date(csrfTokenExpiry)) {
      resolve(csrfToken);
    } else {
      // Fetch a new CSRF token if the current one doesn't exist or is expired
      fetch(BaseURL + '/csrf-token', {
        method: 'GET',
        contentType: 'application/json',
        credentials: 'include', // Include credentials if required
      })
      .then(response => response.json())
      .then(data => {
        csrfToken = data.csrf_token; // Adjust based on your API response
        // Store the token and its expiration time (e.g., 1 hour from now)
        const expiryTime = new Date();
        expiryTime.setMinutes(expiryTime.getMinutes() + 5); // Adjust the expiration time as needed
        sessionStorage.setItem("csrf_token", csrfToken);
        sessionStorage.setItem("csrf_token_expiry", expiryTime.toISOString());
        resolve(csrfToken);
      })
      .catch(error => {
        reject("Failed to fetch CSRF token: " + error);
      });
    }
  });
}

// Function to make the PUT request
export function put(request, body, options = {}) {
  return new Promise((resolve, reject) => {
    getCsrfToken().then(csrfToken => {
      const token = sessionStorage.getItem("authentication");
      options.headers = new Headers({
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "X-CSRF-Token": csrfToken,
      });

      let url = new URL(BaseURL + request);

      fetch(url, {
        method: "PUT",
        body: JSON.stringify(body), // Assuming body is an object
        headers: options.headers,
        credentials: 'include',
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok ' + response.statusText);
        }
        return response.json();
      })
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        console.error("PUT request failed:", error);
        reject(error);
      });
    }).catch(error => {
      reject(error);
    });
  });
}